<template>
  <div>
    <px-aprovacao-solicitacao-item v-for="aprovacao in aprovacoes.content"
                                   :key="aprovacao.id"
                                   :aprovacao="aprovacao"
                                   class="mt-3"/>
    <v-pagination
      class="mt-3"
      v-model="page"
      :length="pagesLimit"
      :total-visible="5"
    ></v-pagination>
  </div>
</template>

<script>
import AprovacaoSolicitacaoItem from '@/modules/aprovacao-solicitacao/AprovacaoSolicitacaoItem.vue';
import AprovacaoSolicitacaoService
  from '@/modules/aprovacao-solicitacao/aprovacao-solicitacao-service';
import paginationMixin from '@/mixins/pagination-mixin';

const LIMIT = 20;
const PAGE = 1;

export default {
  mixins: [paginationMixin],
  data() {
    return {
      page: PAGE,
      pagesLimit: 1,
      loading: false,
      aprovacoes: {
        content: [],
      },
      listOptions: {
        page: PAGE,
        limit: LIMIT,
        offset: 0,
        filter: '',
        sort: 'dataCompra',
        sortDesc: true,
      },
      optionsList: {
        page: PAGE,
        itemsPerPage: LIMIT,
        sortBy: '',
        sortDesc: false,
        multiSort: false,
      },
    };
  },
  methods: {
    onChangeOptions() {
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getAprovacoes();
    },
    setPagesLimit() {
      this.pagesLimit = Math.ceil(this.aprovacoes.total / LIMIT);
    },
    getAprovacoes() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      AprovacaoSolicitacaoService.getList(
        {
          query: '',
          limit,
          offset,
        },
      )
        .then(({ data }) => {
          this.aprovacoes = data;
          this.setPagesLimit();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    page(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.optionsList.page = newValue;
      this.onChangeOptions();
    },
  },
  created() {
    this.getAprovacoes();
  },
  components: {
    pxAprovacaoSolicitacaoItem: AprovacaoSolicitacaoItem,
  },
};
</script>
